<template>
  <BaseFetchData :action="fetchFunnel" v-slot="fetchDataProps">
    <template v-if="fetchDataProps.status.resolved">
      <div>
        <div class="p-8 bg-gray-800">
          <div class="max-w-5xl mx-auto">
            <div class="md:flex md:items-center md:justify-between">
              <div class="flex-1 min-w-0">
                <h2 class="text-2xl font-bold leading-7 text-white sm:text-3xl sm:truncate">
                  {{ funnel.name }} settings
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div class="p-8">
          <div class="max-w-5xl mx-auto">
            <div class="space-y-8">
              <FunnelEdit :funnel="funnel" @updated="setFunnel" />
              <FunnelStageManager :funnel="funnel" />
            </div>
          </div>
        </div>
      </div>
    </template>
  </BaseFetchData>
</template>

<script>
import { funnelsClient } from '@/api/clients';
import FunnelEdit from './settings/components/FunnelEdit.vue';
import FunnelStageManager from './settings/components/FunnelStageManager.vue';

export default {
  components: {
    FunnelEdit,
    FunnelStageManager,
  },
  props: {
    funnelId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      funnel: null,
    };
  },
  methods: {
    setFunnel(funnel) {
      this.funnel = funnel;
    },
    async fetchFunnel() {
      try {
        const response = await funnelsClient.read(this.funnelId);

        this.setFunnel(response.data);

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
